import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '@environment';
import { AlarmSetting } from '@model';

@Injectable()
export class AlarmSettingsService {
 
  constructor(private http: HttpClient) {}

  bulkUpdateAlarmSettings(alarmSettings: AlarmSetting[]): Observable<AlarmSetting[]> {
    return this.http
      .post<AlarmSetting[]>(`${environment.apiEndpoint}/AlarmSettings`, alarmSettings)
      .pipe(catchError((error: any) => throwError(error.json())));
  }

  bulkUpdateNotificationChannels(alarmSettings: AlarmSetting[]): Observable<AlarmSetting[]> {
    return this.http
    .post<AlarmSetting[]>(`${environment.apiEndpoint}/AlarmSettings/bulkupdatenotificationchannel`, alarmSettings)
    .pipe(catchError((error: any) => throwError(error.json())));
  }
}
